import React from 'react';
import { Field } from 'react-final-form';
import { ENV_VARS } from 'ENV_CONFIG';
import { TERMS_CONDITIONS_CONFIG } from '~/components';
import { FormFieldAdapter } from '../form';

import styles from './TermsAndConditionsNotice.scss';

// Validator function for the checkbox
const validateTermsCheckbox = (value) => {
  // Check if checkbox is checked (value can be 'true' string, boolean true, or truthy)
  if (value === true || value === 'true' || !!value) {
    return undefined;
  }
  return 'Please agree to the terms & conditions to continue';
};

export const TermsAndConditionsNotice = () => {
  const label = (
    <div>
      I agree to the&nbsp;
      <a
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/customer-services/shopping-with-us/terms-and-conditions/ocab-terms-conditions`}
        target="_blank"
        rel="noopener noreferrer"
      >
        service appointment terms &amp; conditions
      </a>
      &nbsp;and&nbsp;
      <a
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/customer-services/shopping-with-us/security-and-privacy`}
        target="_blank"
        rel="noopener noreferrer"
      >
        privacy notice
      </a>
      .
    </div>
  );

  return (
    <div className={styles.TermsAndConditions} data-testid="termsConditions">
      <Field
        name="termsConditions.termsConditions"
        type="checkbox"
        parse={(value) => (value ? 'true' : '')}
        validate={validateTermsCheckbox}
      >
        {({ input, meta }) => {
          const showError = (meta.touched || meta.submitFailed) && meta.error;
          return (
            <>
              <FormFieldAdapter
                {...input}
                error={showError}
                meta={meta}
                formFieldConfig={{
                  ...TERMS_CONDITIONS_CONFIG[0],
                  label,
                }}
              />
              {showError && <div className={styles.ErrorMessage}>{meta.error}</div>}
            </>
          );
        }}
      </Field>
    </div>
  );
};

export const MemoizedTermsAndConditionsNotice = React.memo(TermsAndConditionsNotice);
